(function() {
    'use strict';

    const selector = '.gift-data span[data-toggle="modal"]';

    function moveTargetModalToBody(trigger) {
        const targetSelector = trigger.getAttribute('data-target');
        if (!targetSelector) {
            return;
        }

        const modal = document.querySelector(targetSelector);
        if (!modal || !modal.classList || !modal.classList.contains('modal')) {
            return;
        }

        if (modal.parentNode !== document.body) {
            document.body.appendChild(modal);
        }
    }

    function setupGiftModalKeyboardAccess() {
        const triggers = document.querySelectorAll(selector);

        triggers.forEach(function(trigger) {
            trigger.setAttribute('tabindex', '0');
            trigger.setAttribute('role', 'button');
            moveTargetModalToBody(trigger);

            if (trigger.dataset.keyboardBound === 'true') {
                return;
            }

            trigger.addEventListener('keydown', function(event) {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    trigger.click();
                }
            });

            trigger.dataset.keyboardBound = 'true';
        });
    }

    document.addEventListener('DOMContentLoaded', setupGiftModalKeyboardAccess);

    if (window.jQuery) {
        jQuery(document).ajaxComplete(setupGiftModalKeyboardAccess);
    }

    document.addEventListener('keydown', function(e) {
        const el = e.target;
        const isTestTabindex = el.classList.contains('tabindexFocusEl');
        const isButtonRole = el.hasAttribute('role');
        const isTabbable = el.getAttribute('tabindex') === '0';

        if (isTestTabindex && isButtonRole && isTabbable) {
            if (e.key === 'Enter' || e.key === 'Return' || e.key === ' ') {
                e.preventDefault();
                el.click();
            }
        }
    });
})();

// Keyboard activation for Got a Voucher
document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') {
        return;
    }
    const el = document.activeElement;

    if (!el) {
        return;
    }
    if (el.classList && el.classList.contains('closeIconFocus')) {
        el.dispatchEvent(new MouseEvent('click', {
            bubbles: true
        }));
    }
});

// Keyboard activation for Save for Later
document.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter') {
        return;
    }
    let el = document.activeElement;

    if (el && el.classList && el.classList.contains('saveForLaterFocus')) {
        el.querySelector('[data-toggle="modal"]').click();
    }
});

// Focus should move to the first field in the Save for Later modal when it opens
saveForLaterModal.on('shown.bs.modal', function() {
    let firstField = document.querySelector('#save-for-later-form input[name="email"]');
    if (firstField) {
        firstField.focus();
    }
});
// Keyboard activation for radio buttons in the Insure your new mobile section
document.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter') {
        return;
    }
    let el = document.activeElement;

    if (!el || !el.classList) {
        return;
    }
    if (
        el.classList.contains('insuranceRadioFocus') ||
        el.classList.contains('insuranceRadioOptionFocus')
    ) {
        let radio = el.querySelector('input[type="radio"]');

        if (radio) {
            radio.click();
        }
    }
});

// Keyboard activation for Sell my phone header link
document.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter' && e.key !== ' ') {
        return;
    }
    let el = document.activeElement;

    if (el && el.classList && el.classList.contains('smpBasketFocusWrap')) {
        e.preventDefault();
        el.click();
    }
});

// Trap focus inside the modal for Sell my phone header link
document.addEventListener('keydown', function(e) {
    let modal = document.querySelector('#smpContent');
    let trigger = document.querySelector('.smpBasketFocusWrap');
    let isDesktopOpen = modal && modal.classList.contains('in');

    let sidepanel = document.querySelector('#smpSidepanel');
    let isMobileOpen = sidepanel &&
        window.getComputedStyle(sidepanel).display !== 'none' &&
        sidepanel.offsetWidth > 0;

    let activeContainer = isMobileOpen ? sidepanel : (isDesktopOpen ? modal : null);

    if (!activeContainer || e.key !== 'Tab') {
        return;
    }
    let f = activeContainer.querySelectorAll(
        'button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (!f.length) {
        return;
    }
    let first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (e.shiftKey && a === first) {
        e.preventDefault();
        trigger.focus();
    }
    if (!e.shiftKey && a === last) {
        e.preventDefault();
        trigger.focus();
    }
});

// Keyboard activation for the tooltip buttons within the Your package section
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.promo-offer-banner span[data-toggle="modal"]').forEach(function(trigger) {
        trigger.setAttribute('tabindex', '0');
        trigger.setAttribute('role', 'button');

        trigger.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                trigger.click();
            }
        });
    });
});

// Keyboard activation for plan details button in the basket
$(document).ready(function() {
    let lastFocusedElement = null;
    $(document).on('keydown', '.basketPlanDetailsFocus', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            lastFocusedElement = this;
            $(this).trigger('click');
        }
    });

    $(document).on('click', '.basketPlanDetailsFocus', function() {
        lastFocusedElement = this;
    });

    $(document).on('shown.bs.modal', '.plandetails-popup', function() {
        $(this).find('button.close').first().focus();
    });

    $(document).on('click', '.plandetails-popup button.close', function() {
        if (lastFocusedElement) {
            $(lastFocusedElement).focus();
        }
    });

    $(document).on('hidden.bs.modal', '.plandetails-popup', function() {
        if (lastFocusedElement) {
            $(lastFocusedElement).focus();
        }
    });
});

// Accessibility: Keyboard focus on checkout form errors
(function() {
    const form = document.querySelector('form.checkout-error-accessibility');
    if (!form) {
        return;
    }
    const submitBtn = form.querySelector('#delivery');
    const liveRegion = form.querySelector('#form-errors');
    form.querySelectorAll('.form-section-radio-buttons').forEach((section, index) => {
        const helpBlock = section.querySelector('.help-block');
        if (!helpBlock) {
            return;
        }
        if (!helpBlock.id) {
            helpBlock.id = `radio-error-${index}`;
        }
        section.querySelectorAll('input[type="radio"]').forEach((radio) => {
            radio.setAttribute('aria-describedby', helpBlock.id);
        });
    });

    function getFirstInvalidGroup() {
        return form.querySelector('.form-group.is-invalid');
    }
    function focusAndAnnounceError() {
        const group = getFirstInvalidGroup();
        if (!group) {
            return;
        }
        const field = group.querySelector(
            'input, select, textarea'
        );
        const error = group.querySelector('.help-block');
        if (field) {
            field.focus();
            field.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
        if (liveRegion && error) {
            liveRegion.textContent = '';
            liveRegion.textContent = error.textContent.trim();
        }
    }
    if (submitBtn) {
        submitBtn.addEventListener('click', function(e) {
            const invalidGroup = getFirstInvalidGroup();
            if (invalidGroup) {
                e.preventDefault();
                focusAndAnnounceError();
            }
        });
    }
})();

// Accessibility: Enable autocomplete for job title field
function setAutocomplete() {
    const el = document.querySelector('[data-field-job-title] #form_employment_jobTitle');
    if (el) {
        el.setAttribute('autocomplete', 'on');
    }
}

document.addEventListener('DOMContentLoaded', function() {
    setAutocomplete();
    setTimeout(setAutocomplete, 1500);
});

$(document).ready(function() {
    const $input = $('#form_employment_jobTitle');
    const $label = $('label[for="form_employment_jobTitle"]');
    const $listbox = $('.tt-menu');

    // Add ID to label
    if (!$label.attr('id')) {
        $label.attr('id', 'jobTitleLabel');
    }
    // Input ARIA
    $input.attr({
        role: 'combobox',
        'aria-autocomplete': 'list',
        'aria-expanded': 'false',
        'aria-controls': 'jobTitleList',
        'aria-labelledby': $label.attr('id')
    });
    // Listbox ARIA
    $listbox.attr({
        id: 'jobTitleList',
        role: 'listbox',
        'aria-labelledby': $label.attr('id')
    });
    // FUNCTION: Apply roles to options
    function applyOptionRoles() {
        $('.tt-suggestion').each(function(index) {
            $(this).attr({
                role: 'option',
                id: 'jobTitle-option-' + index,
                'aria-selected': 'false'
            });
        });
    }
    // KEY FIX: Use Typeahead events
    $input.on('typeahead:render typeahead:open', function() {
        applyOptionRoles();
        $input.attr('aria-expanded', 'true');
    });

    $input.on('typeahead:close', function() {
        $input.attr('aria-expanded', 'false');
    });
    // Keyboard navigation
    let currentIndex = -1;
    $input.on('keydown', function(e) {
        const $options = $('.tt-suggestion');
        if (!$options.length) {
            return;
        }
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            currentIndex = (currentIndex + 1) % $options.length;
            setActive($options, currentIndex);
        }
        if (e.key === 'ArrowUp') {
            e.preventDefault();
            currentIndex = (currentIndex - 1 + $options.length) % $options.length;
            setActive($options, currentIndex);
        }
        if (e.key === 'Enter' && currentIndex >= 0) {
            e.preventDefault();
            selectOption($options.eq(currentIndex));
        }
    });
    // Mouse selection
    $(document).on('click', '.tt-suggestion', function() {
        selectOption($(this));
    });
    function setActive($options, index) {
        $options.attr('aria-selected', 'false');
        const $active = $options.eq(index);
        $active.attr('aria-selected', 'true');
        $input.attr('aria-activedescendant', $active.attr('id'));
    }
    function selectOption($option) {
        $input.val($option.text());
        $input.attr({
            'aria-activedescendant': $option.attr('id'),
            'aria-expanded': 'false'
        });
        $option.attr('aria-selected', 'true');
    }
});

// Sell My Phone toggle accessible naming
(function() {
    const header = document.querySelector('.smp-basket-header');
    if (!header) {
        return;
    }

    const collapsedLabel = header.getAttribute('aria-label');
    const expandedLabel = 'Close sell my phone Get up to £410 for your old phone';
    const updateSmpAriaLabel = function() {
        const isExpanded = header.classList.contains('open');
        header.setAttribute('aria-label', isExpanded ? expandedLabel : collapsedLabel);
    };

    updateSmpAriaLabel();
    new MutationObserver(updateSmpAriaLabel).observe(header, {
        attributes: true,
        attributeFilter: ['class']
    });
})();

// Accessible name for Tech Insurance modal
const wrapper = document.querySelector('.basket-data-insurance-wrapper');
if (wrapper) {
    const modal = wrapper.querySelector('.insurance-ipid-modal');

    if (modal) {
        const observer = new MutationObserver(() => {
            if (modal.classList.contains('in')) {
                modal.setAttribute('aria-label', 'Tech Insurance Information');
            } else {
                modal.removeAttribute('aria-label');
            }
        });

        observer.observe(modal, {
            attributes: true,
            attributeFilter: ['class']
        });
    }
}
